/**
 * 記事の見出しから目次生成
 */
const mokujiHead6 = document.querySelector("#mokuji-head-6");
const mokujiHead2 = document.querySelector("#mokuji-head-2");
const mokujiSide = document.querySelector("#mokuji-side");


/**
 * 生成目次の制限
 */
document.addEventListener('DOMContentLoaded', () => {
    // h2〜h6
    if (mokujiHead6) {
        generateToc(mokujiHead6, 'h2, h3, h4, h5, h6');
    }
    // h2のみ
    if (mokujiHead2) {
        generateContents(mokujiHead2, 'h2,h3');
    }
    // サイドバー用目次（h2のみ）
    if (mokujiSide) {
        generateToc(mokujiSide, 'h2');
        handleTableOfContents(mokujiSide);
    }
});

/**
 * 目次生成実行
 */
function generateToc(targetElement, selectors) {
    const heads = document.querySelectorAll(selectors);
    if (heads && heads.length) {
        let contents = '';
        heads.forEach((head, i) => {
            head.id = `head-${i}`;
            contents += `<li class="head-${head.localName}"><a href="#head-${i}">${head.textContent}</a></li>`;
        });
        targetElement.innerHTML += `<ol class="c-outline__toc_list">${contents}</ol>`;
    }
}

/**
 * 目次生成実行(h3およびトグルありの場合)
 */
function generateContents(targetElement, selectors) {
    const heads = Array.from(document.querySelectorAll(selectors));
    if (!heads.length) return;

    let contents = '';
    let h2Counter = -1;
    let h3Counter = -1;
    let currentH2Id = '';
    let h2Map = new Map(); // h2 ID => h3の数

    heads.forEach((head) => {
        let headId;
        let className = `head-${head.localName}`;

        if (head.localName === 'h2') {
            h2Counter++;
            h3Counter = -1;
            headId = `head-${h2Counter}`;
            currentH2Id = headId;
            h2Map.set(currentH2Id, 0);
            className += ' no-width-h2';
        } else if (head.localName === 'h3') {
            h3Counter++;
            headId = `head-${h2Counter}-${h3Counter}`;
            className += ' no-width-h3 c-mokuji-close';
            // h3があるので、親h2にカウント足す
            h2Map.set(currentH2Id, h2Map.get(currentH2Id) + 1);
        }

        head.id = headId;
        contents += `<li class="${className}" data-h2-id="${currentH2Id}"><a href="#${headId}">${head.textContent}</a></li>`;
    });

    // h2に対応するh3がある場合のみトグル追加クラスを付与
    contents = contents.replace(/<li class="head-h2 no-width-h2"(.*?)data-h2-id="(head-\d+)"/g, (match, p1, h2Id) => {
        if (h2Map.get(h2Id) > 0) {
            return `<li class="head-h2 no-width-h2 addToggle"${p1}data-h2-id="${h2Id}"`;
        }
        return match;
    });

    targetElement.innerHTML += `<ol class="c-outline__toc_list">${contents}</ol>`;
    addToggleFunction(targetElement);
}

/**
 * トグルボタンの追加
 */
function addToggleFunction(targetElement) {
    const toggleItems = targetElement.querySelectorAll('.addToggle');
    toggleItems.forEach(item => {
        const container = document.createElement('div');
        container.className = 'c-toggle-position';

        const link = item.querySelector('a');
        container.appendChild(link);

        const toggleButton = document.createElement('button');
        toggleButton.className = 'c-mokuji-toggle';
        container.appendChild(toggleButton);

        item.innerHTML = '';
        item.appendChild(container);

        toggleButton.addEventListener('click', function(e) {
            e.preventDefault();
            toggleH3Items(item, this);
        });
    });
}

/**
 * トグルボタンの開閉処理
 */
function toggleH3Items(h2Item, toggleButton) {
    const h3Items = [];
    // forループで次の要素をチェック
    for (
      let nextElement = h2Item.nextElementSibling;
      nextElement && !nextElement.classList.contains('head-h2');
      nextElement = nextElement.nextElementSibling
    ) {
        if (nextElement.classList.contains('head-h3')) {
            h3Items.push(nextElement);
        }
    }
    const isHidden = h3Items[0].classList.contains('c-mokuji-close');
    for (let i = 0; i < h3Items.length; i++) {
        h3Items[i].classList.toggle('c-mokuji-close', !isHidden);
        h3Items[i].classList.toggle('c-mokuji-open', isHidden);
    }
    toggleButton.classList.toggle('is-mokiji-open', isHidden);
}

/**
 * 目次のスクロール
 */
function handleTableOfContents(tocContainer) {
    const tocLinks = tocContainer.querySelectorAll('a');
    const sections = Array.from(document.querySelectorAll('h2,h3'));

    tocLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    window.addEventListener('scroll', function() {
        let fromTop = window.scrollY;
        let currentSection = sections.find(section => {
            return section.offsetTop <= fromTop + 100 && section.offsetTop + section.offsetHeight > fromTop + 30;
        });

        if (currentSection) {
            let tocLinksArray = Array.from(tocLinks);
            let currentLink = tocLinksArray.find(link => `#${currentSection.id}` === link.getAttribute('href'));
            tocLinksArray.forEach(link => link.classList.remove('is-active'));
            if (currentLink) {
                currentLink.classList.add('is-active');
            }
        }
    });
}
